export default __webpack_public_path__ + "static/media/27.e28915c1.jpeg";